import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { BugReportComponent } from '@shared/components/bug-report/bug-report.component';

@Component({
    selector: 'app-bug-report-button',
    template: '<div>' + '<button (click)="openDialog()" class="green-button">Report Bug</button>' + '</div>',
    styleUrls: ['./bug-report.component.scss'],
    standalone: false
})
export class BugReportButtonComponent {
    bugReportDialogRef: MatDialogRef<BugReportComponent>;
    form: UntypedFormGroup;
    description: string;

    constructor(private dialog: MatDialog) {}

    openDialog(): void {
        this.bugReportDialogRef = this.dialog.open(BugReportComponent);
    }
}
